import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/12_green_field/12_green_field"
 * Contains 1 texture(s)
 */
export class Tablet12GreenFieldAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/12_green_field/12_green_field';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '12_green_field.jpg'
    ] as const;
}
